(function($, Drupal, once) {
  'use strict';

  Drupal.behaviors.certSenderFaq = {
    attach: function(context, settings) {
      const elements = $(once('cert-sender-faq', '#block-certsenderfaqs', context));
      elements.each(function() {
        const $faqLink = $('.region-help-area').find('[href="#block-certsenderfaqs"]');
        const $faqCollapse = $('#paragraphsCollapse');

        // Clicking the faq anchor link opens top level collapse
        $faqLink.on('click', function () {
          $faqCollapse.collapse('show')
        });
      });
    }
  };

})(jQuery, Drupal, once);
